import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { House, Storefront, QrCode, Bell, SignOut, Scan, ShieldCheck, Gift } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

const tabs = [
  { to: "/app", icon: House, label: "Home", end: true },
  { to: "/app/businesses", icon: Storefront, label: "Businesses" },
  { to: "/app/scan", icon: Scan, label: "Scan" },
  { to: "/app/qr", icon: QrCode, label: "My QR" },
  { to: "/app/rewards", icon: Gift, label: "Rewards" },
  { to: "/app/notifications", icon: Bell, label: "Alerts" },
];

export default function CustomerLayout() {
  const { logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen ok-bg grain relative">
      <div className="max-w-md mx-auto min-h-screen flex flex-col relative">
        <header className="flex items-center justify-between px-5 pt-6 pb-2">
          <Logo className="h-7" />
          <div className="flex items-center gap-3">
            <NavLink to="/app/security" data-testid="customer-security-link" title="Devices & sessions"
              className={({ isActive }) => `hover:text-foreground ${isActive ? "text-primary" : "text-muted-foreground"}`}>
              <ShieldCheck size={20} />
            </NavLink>
            <button data-testid="customer-logout" onClick={() => { logout(); nav("/login"); }} className="text-muted-foreground hover:text-foreground">
              <SignOut size={20} />
            </button>
          </div>
        </header>

        <main className="flex-1 px-5 pb-28">
          <Outlet />
        </main>

        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md px-4 pb-4 pt-2">
          <div className="glass rounded-2xl flex justify-around py-2">
            {tabs.map((t) => (
              <NavLink key={t.to} to={t.to} end={t.end} data-testid={`nav-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-colors ${isActive ? "text-primary" : "text-muted-foreground"}`}>
                {({ isActive }) => (
                  <>
                    <t.icon size={22} weight={isActive ? "fill" : "regular"} />
                    <span className="text-[10px] font-medium">{t.label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}
